import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TaskStep } from 'app-models';
import { PrimeIcons } from 'primeng/api';
import { TaskNotesService } from 'task-notes-lib';
import { ImagilityBaseResponse } from 'app-models';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-i140-timeline',
  templateUrl: './i140-timeline.component.html',
  styleUrls: ['./i140-timeline.component.scss']
})
export class I140TimelineComponent implements OnInit, OnChanges {

  @Input()
  inputStepList: TaskStep[];

  @Output()
  onStepClick: EventEmitter<TaskStep> = new EventEmitter();
  toolTipCustomClass:any;
  userType: string;
  stepList: TaskStep[]; // Holding step list passed by pa rent
  observableSubscription$ = new Subject();

  constructor(
    private taskNotesService: TaskNotesService    
  ) {
    this.stepList = [];
    this.userType = sessionStorage.getItem("userTypeRole");
    
  }

  ngOnInit(): void {
    
   }

  ngOnChanges(e: SimpleChanges) {
    if (e.inputStepList && e.inputStepList.currentValue) {
      this.stepList = e.inputStepList.currentValue;
    }
  }

  handleStepClick(step: TaskStep) {
    this.onStepClick.emit(step);
  }
  updateNoteAvailability(e, step){
    step.notesAvailable = e?.notesAvailable || false;    
    step.notes.noteText = e.noteText || '';   
  }
  updateLockUnlock(e, step) {
    step.locked = e?.locked;
    step.taskId = e.taskId;
    step.stepId = e.stepId;
    step.userType = e.userType;
  }
  mouseEnter(param) {
    this.toolTipCustomClass = param;
  }
}
